import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Box, Tab, TextField } from "@mui/material";
import { CSSProperties, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectEditMode } from "../../../../store/user/selector";
import { LogError } from "../../../../tools/log";
import { CloseButton, SaveButton } from "./Buttons";
import { Loading } from "./common";

export interface DivHTMLTextProps {
    text: string;
    saveText?: (t: string) => void;
    style?: CSSProperties;
    saveRealTime?: boolean;
}

export function DivHTMLText(props: DivHTMLTextProps) {
    const { text, saveText, style, saveRealTime } = props;

    const editMode = useSelector(selectEditMode);

    return (
        <Box sx={{ display: "flex", width: "100%" }}>
            {editMode ? (
                <HTMLTextEdit text={text} onSave={saveText} saveReatime={saveRealTime} />
            ) : (
                <HTMLTextDisplay text={text} style={style} />
            )}
        </Box>
    );
}

interface HTMLTextEditProps {
    text: string;
    onSave?: (s: string) => void;
    saveReatime?: boolean; // 没有保存按钮, 每次修改都立即保存
}

function HTMLTextEdit(props: HTMLTextEditProps) {
    const { text, onSave, saveReatime } = props;
    const [draft, setDraft] = useState(text);
    const [tabIndex, setTabIndex] = useState("1");

    useEffect(() => {
        setDraft(text);
        if (!saveReatime) {
            setTabIndex("3");
        }
    }, [text]);

    const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
        setTabIndex(newValue);
    };

    const value = saveReatime ? text : draft;
    const handleChangeValue = saveReatime
        ? (s: string) => {
              if (onSave) onSave(s);
          }
        : setDraft;

    const saveDiv = (
        <>
            {draft !== text && (
                <>
                    {onSave !== undefined && <SaveButton onClick={() => onSave(draft)} />}
                    <CloseButton onClick={() => setDraft(text)} />
                </>
            )}
        </>
    );

    return (
        <>
            <Box sx={{ width: "100%" }}>
                <TabContext value={tabIndex}>
                    <Box>
                        <TabList onChange={handleChangeTab}>
                            <Tab label="代码" value="1" />
                            {/* <Tab label="文本编辑框" value="2" /> */}
                            <Tab label="预览" value="3" />
                        </TabList>
                    </Box>
                    <TabPanel value="1">
                        <TextField
                            label="html"
                            size="small"
                            color="info"
                            sx={{ minWidth: "500px" }}
                            fullWidth
                            multiline
                            value={value}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                let val = event.target.value.replace(/\$\$\$/g, "\n");
                                handleChangeValue(val);
                                // setDraft(val);
                            }}
                        />
                        {!saveReatime && saveDiv}
                    </TabPanel>
                    <TabPanel value="3">
                        <HTMLTextDisplay text={draft} />
                    </TabPanel>
                </TabContext>
            </Box>
        </>
    );
}

interface HTMLTextDisplayProps {
    text: string;
    style?: CSSProperties;
}

export function HTMLTextDisplay(props: HTMLTextDisplayProps) {
    const { text, style: refStyle } = props;

    const [mathJaxRendered, setMathJaxRendered] = useState(false);
    useEffect(() => {
        setMathJaxRendered(false);
        const MathJax = (window as any).MathJax;
        if (MathJax && MathJax.typesetPromise) {
            window.MathJax.typesetClear();
            window.MathJax.typesetPromise()
                .then(() => {
                    // console.log("MathJax formulas have been re-rendered.");
                    setMathJaxRendered(true); // 更新状态为已渲染
                })
                .catch((err: any) => LogError("MathJax rendering error:", err));
        }
    }, [text]);

    return (
        <>
            {!mathJaxRendered && <Loading />}
            <div
                style={{
                    maxWidth: "100%",
                    visibility: mathJaxRendered ? "visible" : "hidden",
                    ...refStyle,
                }}
                dangerouslySetInnerHTML={{ __html: text }}
            ></div>
        </>
    );
}
